// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

// This was generated using spacetimedb cli version 1.3.0 (commit ).

/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
import {
  AlgebraicType,
  AlgebraicValue,
  BinaryReader,
  BinaryWriter,
  ConnectionId,
  DbConnectionBuilder,
  DbConnectionImpl,
  Identity,
  ProductType,
  ProductTypeElement,
  SubscriptionBuilderImpl,
  SumType,
  SumTypeVariant,
  TableCache,
  TimeDuration,
  Timestamp,
  deepEqual,
  type CallReducerFlags,
  type DbContext,
  type ErrorContextInterface,
  type Event,
  type EventContextInterface,
  type ReducerEventContextInterface,
  type SubscriptionEventContextInterface,
} from "@clockworklabs/spacetimedb-sdk";

// Import and reexport all reducer arg types
import { AddAreaOfEffect } from "./add_area_of_effect_reducer.ts";
export { AddAreaOfEffect };
import { AddCharacter } from "./add_character_reducer.ts";
export { AddCharacter };
import { AddEffect } from "./add_effect_reducer.ts";
export { AddEffect };
import { AddPointer } from "./add_pointer_reducer.ts";
export { AddPointer };
import { BroadcastDice } from "./broadcast_dice_reducer.ts";
export { BroadcastDice };
import { ClearPointers } from "./clear_pointers_reducer.ts";
export { ClearPointers };
import { CreateTabletop } from "./create_tabletop_reducer.ts";
export { CreateTabletop };
import { DeleteTabletop } from "./delete_tabletop_reducer.ts";
export { DeleteTabletop };
import { EditPlayer } from "./edit_player_reducer.ts";
export { EditPlayer };
import { IdentityConnected } from "./identity_connected_reducer.ts";
export { IdentityConnected };
import { IdentityDisconnected } from "./identity_disconnected_reducer.ts";
export { IdentityDisconnected };
import { MoveAreaOfEffect } from "./move_area_of_effect_reducer.ts";
export { MoveAreaOfEffect };
import { MoveCharacter } from "./move_character_reducer.ts";
export { MoveCharacter };
import { RemoveAreaOfEffect } from "./remove_area_of_effect_reducer.ts";
export { RemoveAreaOfEffect };
import { RemoveCharacter } from "./remove_character_reducer.ts";
export { RemoveCharacter };
import { RemoveEffect } from "./remove_effect_reducer.ts";
export { RemoveEffect };
import { SetCharacterAura } from "./set_character_aura_reducer.ts";
export { SetCharacterAura };
import { SetCharacterConditions } from "./set_character_conditions_reducer.ts";
export { SetCharacterConditions };
import { SetCharacterInitiative } from "./set_character_initiative_reducer.ts";
export { SetCharacterInitiative };
import { SetEncounter } from "./set_encounter_reducer.ts";
export { SetEncounter };
import { SetPageData } from "./set_page_data_reducer.ts";
export { SetPageData };
import { UpdateResource } from "./update_resource_reducer.ts";
export { UpdateResource };

// Import and reexport all table handle types
import { AreasTableHandle } from "./areas_table.ts";
export { AreasTableHandle };
import { CharacterTableHandle } from "./character_table.ts";
export { CharacterTableHandle };
import { DiceResultTableHandle } from "./dice_result_table.ts";
export { DiceResultTableHandle };
import { EffectsTableHandle } from "./effects_table.ts";
export { EffectsTableHandle };
import { PageDataTableHandle } from "./page_data_table.ts";
export { PageDataTableHandle };
import { PlayerTableHandle } from "./player_table.ts";
export { PlayerTableHandle };
import { PointersTableHandle } from "./pointers_table.ts";
export { PointersTableHandle };
import { ResourcesTableHandle } from "./resources_table.ts";
export { ResourcesTableHandle };
import { TabletopTableHandle } from "./tabletop_table.ts";
export { TabletopTableHandle };

// Import and reexport all types
import { AreaOfEffect } from "./area_of_effect_type.ts";
export { AreaOfEffect };
import { Character } from "./character_type.ts";
export { Character };
import { DiceResult } from "./dice_result_type.ts";
export { DiceResult };
import { Effect } from "./effect_type.ts";
export { Effect };
import { PageData } from "./page_data_type.ts";
export { PageData };
import { Player } from "./player_type.ts";
export { Player };
import { PlayerData } from "./player_data_type.ts";
export { PlayerData };
import { Point } from "./point_type.ts";
export { Point };
import { Pointer } from "./pointer_type.ts";
export { Pointer };
import { Resource } from "./resource_type.ts";
export { Resource };
import { SetChar } from "./set_char_type.ts";
export { SetChar };
import { SetEncounterData } from "./set_encounter_data_type.ts";
export { SetEncounterData };
import { SetFog } from "./set_fog_type.ts";
export { SetFog };
import { SetMap } from "./set_map_type.ts";
export { SetMap };
import { Tabletop } from "./tabletop_type.ts";
export { Tabletop };

const REMOTE_MODULE = {
  tables: {
    areas: {
      tableName: "areas",
      rowType: AreaOfEffect.getTypeScriptAlgebraicType(),
      primaryKey: "id",
      primaryKeyInfo: {
        colName: "id",
        colType: AreaOfEffect.getTypeScriptAlgebraicType().product.elements[0].algebraicType,
      },
    },
    character: {
      tableName: "character",
      rowType: Character.getTypeScriptAlgebraicType(),
      primaryKey: "id",
      primaryKeyInfo: {
        colName: "id",
        colType: Character.getTypeScriptAlgebraicType().product.elements[0].algebraicType,
      },
    },
    dice_result: {
      tableName: "dice_result",
      rowType: DiceResult.getTypeScriptAlgebraicType(),
      primaryKey: "id",
      primaryKeyInfo: {
        colName: "id",
        colType: DiceResult.getTypeScriptAlgebraicType().product.elements[0].algebraicType,
      },
    },
    effects: {
      tableName: "effects",
      rowType: Effect.getTypeScriptAlgebraicType(),
      primaryKey: "id",
      primaryKeyInfo: {
        colName: "id",
        colType: Effect.getTypeScriptAlgebraicType().product.elements[0].algebraicType,
      },
    },
    page_data: {
      tableName: "page_data",
      rowType: PageData.getTypeScriptAlgebraicType(),
      primaryKey: "page",
      primaryKeyInfo: {
        colName: "page",
        colType: PageData.getTypeScriptAlgebraicType().product.elements[0].algebraicType,
      },
    },
    player: {
      tableName: "player",
      rowType: Player.getTypeScriptAlgebraicType(),
      primaryKey: "identity",
      primaryKeyInfo: {
        colName: "identity",
        colType: Player.getTypeScriptAlgebraicType().product.elements[0].algebraicType,
      },
    },
    pointers: {
      tableName: "pointers",
      rowType: Pointer.getTypeScriptAlgebraicType(),
      primaryKey: "id",
      primaryKeyInfo: {
        colName: "id",
        colType: Pointer.getTypeScriptAlgebraicType().product.elements[0].algebraicType,
      },
    },
    resources: {
      tableName: "resources",
      rowType: Resource.getTypeScriptAlgebraicType(),
      primaryKey: "id",
      primaryKeyInfo: {
        colName: "id",
        colType: Resource.getTypeScriptAlgebraicType().product.elements[0].algebraicType,
      },
    },
    tabletop: {
      tableName: "tabletop",
      rowType: Tabletop.getTypeScriptAlgebraicType(),
      primaryKey: "id",
      primaryKeyInfo: {
        colName: "id",
        colType: Tabletop.getTypeScriptAlgebraicType().product.elements[0].algebraicType,
      },
    },
  },
  reducers: {
    add_area_of_effect: {
      reducerName: "add_area_of_effect",
      argsType: AddAreaOfEffect.getTypeScriptAlgebraicType(),
    },
    add_character: {
      reducerName: "add_character",
      argsType: AddCharacter.getTypeScriptAlgebraicType(),
    },
    add_effect: {
      reducerName: "add_effect",
      argsType: AddEffect.getTypeScriptAlgebraicType(),
    },
    add_pointer: {
      reducerName: "add_pointer",
      argsType: AddPointer.getTypeScriptAlgebraicType(),
    },
    broadcast_dice: {
      reducerName: "broadcast_dice",
      argsType: BroadcastDice.getTypeScriptAlgebraicType(),
    },
    clear_pointers: {
      reducerName: "clear_pointers",
      argsType: ClearPointers.getTypeScriptAlgebraicType(),
    },
    create_tabletop: {
      reducerName: "create_tabletop",
      argsType: CreateTabletop.getTypeScriptAlgebraicType(),
    },
    delete_tabletop: {
      reducerName: "delete_tabletop",
      argsType: DeleteTabletop.getTypeScriptAlgebraicType(),
    },
    edit_player: {
      reducerName: "edit_player",
      argsType: EditPlayer.getTypeScriptAlgebraicType(),
    },
    identity_connected: {
      reducerName: "identity_connected",
      argsType: IdentityConnected.getTypeScriptAlgebraicType(),
    },
    identity_disconnected: {
      reducerName: "identity_disconnected",
      argsType: IdentityDisconnected.getTypeScriptAlgebraicType(),
    },
    move_area_of_effect: {
      reducerName: "move_area_of_effect",
      argsType: MoveAreaOfEffect.getTypeScriptAlgebraicType(),
    },
    move_character: {
      reducerName: "move_character",
      argsType: MoveCharacter.getTypeScriptAlgebraicType(),
    },
    remove_area_of_effect: {
      reducerName: "remove_area_of_effect",
      argsType: RemoveAreaOfEffect.getTypeScriptAlgebraicType(),
    },
    remove_character: {
      reducerName: "remove_character",
      argsType: RemoveCharacter.getTypeScriptAlgebraicType(),
    },
    remove_effect: {
      reducerName: "remove_effect",
      argsType: RemoveEffect.getTypeScriptAlgebraicType(),
    },
    set_character_aura: {
      reducerName: "set_character_aura",
      argsType: SetCharacterAura.getTypeScriptAlgebraicType(),
    },
    set_character_conditions: {
      reducerName: "set_character_conditions",
      argsType: SetCharacterConditions.getTypeScriptAlgebraicType(),
    },
    set_character_initiative: {
      reducerName: "set_character_initiative",
      argsType: SetCharacterInitiative.getTypeScriptAlgebraicType(),
    },
    set_encounter: {
      reducerName: "set_encounter",
      argsType: SetEncounter.getTypeScriptAlgebraicType(),
    },
    set_page_data: {
      reducerName: "set_page_data",
      argsType: SetPageData.getTypeScriptAlgebraicType(),
    },
    update_resource: {
      reducerName: "update_resource",
      argsType: UpdateResource.getTypeScriptAlgebraicType(),
    },
  },
  versionInfo: {
    cliVersion: "1.3.0",
  },
  // Constructors which are used by the DbConnectionImpl to
  // extract type information from the generated RemoteModule.
  //
  // NOTE: This is not strictly necessary for `eventContextConstructor` because
  // all we do is build a TypeScript object which we could have done inside the
  // SDK, but if in the future we wanted to create a class this would be
  // necessary because classes have methods, so we'll keep it.
  eventContextConstructor: (imp: DbConnectionImpl, event: Event<Reducer>) => {
    return {
      ...(imp as DbConnection),
      event
    }
  },
  dbViewConstructor: (imp: DbConnectionImpl) => {
    return new RemoteTables(imp);
  },
  reducersConstructor: (imp: DbConnectionImpl, setReducerFlags: SetReducerFlags) => {
    return new RemoteReducers(imp, setReducerFlags);
  },
  setReducerFlagsConstructor: () => {
    return new SetReducerFlags();
  }
}

// A type representing all the possible variants of a reducer.
export type Reducer = never
| { name: "AddAreaOfEffect", args: AddAreaOfEffect }
| { name: "AddCharacter", args: AddCharacter }
| { name: "AddEffect", args: AddEffect }
| { name: "AddPointer", args: AddPointer }
| { name: "BroadcastDice", args: BroadcastDice }
| { name: "ClearPointers", args: ClearPointers }
| { name: "CreateTabletop", args: CreateTabletop }
| { name: "DeleteTabletop", args: DeleteTabletop }
| { name: "EditPlayer", args: EditPlayer }
| { name: "IdentityConnected", args: IdentityConnected }
| { name: "IdentityDisconnected", args: IdentityDisconnected }
| { name: "MoveAreaOfEffect", args: MoveAreaOfEffect }
| { name: "MoveCharacter", args: MoveCharacter }
| { name: "RemoveAreaOfEffect", args: RemoveAreaOfEffect }
| { name: "RemoveCharacter", args: RemoveCharacter }
| { name: "RemoveEffect", args: RemoveEffect }
| { name: "SetCharacterAura", args: SetCharacterAura }
| { name: "SetCharacterConditions", args: SetCharacterConditions }
| { name: "SetCharacterInitiative", args: SetCharacterInitiative }
| { name: "SetEncounter", args: SetEncounter }
| { name: "SetPageData", args: SetPageData }
| { name: "UpdateResource", args: UpdateResource }
;

export class RemoteReducers {
  constructor(private connection: DbConnectionImpl, private setCallReducerFlags: SetReducerFlags) {}

  addAreaOfEffect(tabletop: number, origin: Point, target: Point, shape: string) {
    const __args = { tabletop, origin, target, shape };
    let __writer = new BinaryWriter(1024);
    AddAreaOfEffect.getTypeScriptAlgebraicType().serialize(__writer, __args);
    let __argsBuffer = __writer.getBuffer();
    this.connection.callReducer("add_area_of_effect", __argsBuffer, this.setCallReducerFlags.addAreaOfEffectFlags);
  }

  onAddAreaOfEffect(callback: (ctx: ReducerEventContext, tabletop: number, origin: Point, target: Point, shape: string) => void) {
    this.connection.onReducer("add_area_of_effect", callback);
  }

  removeOnAddAreaOfEffect(callback: (ctx: ReducerEventContext, tabletop: number, origin: Point, target: Point, shape: string) => void) {
    this.connection.offReducer("add_area_of_effect", callback);
  }

  addCharacter(tabletop: number, name: string, friendly: boolean, sprite: string, size: number, position: Point | undefined, initMod: number | undefined) {
    const __args = { tabletop, name, friendly, sprite, size, position, initMod };
    let __writer = new BinaryWriter(1024);
    AddCharacter.getTypeScriptAlgebraicType().serialize(__writer, __args);
    let __argsBuffer = __writer.getBuffer();
    this.connection.callReducer("add_character", __argsBuffer, this.setCallReducerFlags.addCharacterFlags);
  }

  onAddCharacter(callback: (ctx: ReducerEventContext, tabletop: number, name: string, friendly: boolean, sprite: string, size: number, position: Point | undefined, initMod: number | undefined) => void) {
    this.connection.onReducer("add_character", callback);
  }

  removeOnAddCharacter(callback: (ctx: ReducerEventContext, tabletop: number, name: string, friendly: boolean, sprite: string, size: number, position: Point | undefined, initMod: number | undefined) => void) {
    this.connection.offReducer("add_character", callback);
  }

  addEffect(tabletop: number, origin: Point, target: Point, kind: string) {
    const __args = { tabletop, origin, target, kind };
    let __writer = new BinaryWriter(1024);
    AddEffect.getTypeScriptAlgebraicType().serialize(__writer, __args);
    let __argsBuffer = __writer.getBuffer();
    this.connection.callReducer("add_effect", __argsBuffer, this.setCallReducerFlags.addEffectFlags);
  }

  onAddEffect(callback: (ctx: ReducerEventContext, tabletop: number, origin: Point, target: Point, kind: string) => void) {
    this.connection.onReducer("add_effect", callback);
  }

  removeOnAddEffect(callback: (ctx: ReducerEventContext, tabletop: number, origin: Point, target: Point, kind: string) => void) {
    this.connection.offReducer("add_effect", callback);
  }

  addPointer(tabletop: number, origin: Point, target: Point) {
    const __args = { tabletop, origin, target };
    let __writer = new BinaryWriter(1024);
    AddPointer.getTypeScriptAlgebraicType().serialize(__writer, __args);
    let __argsBuffer = __writer.getBuffer();
    this.connection.callReducer("add_pointer", __argsBuffer, this.setCallReducerFlags.addPointerFlags);
  }

  onAddPointer(callback: (ctx: ReducerEventContext, tabletop: number, origin: Point, target: Point) => void) {
    this.connection.onReducer("add_pointer", callback);
  }

  removeOnAddPointer(callback: (ctx: ReducerEventContext, tabletop: number, origin: Point, target: Point) => void) {
    this.connection.offReducer("add_pointer", callback);
  }

  broadcastDice(dice: string, timestamp: number) {
    const __args = { dice, timestamp };
    let __writer = new BinaryWriter(1024);
    BroadcastDice.getTypeScriptAlgebraicType().serialize(__writer, __args);
    let __argsBuffer = __writer.getBuffer();
    this.connection.callReducer("broadcast_dice", __argsBuffer, this.setCallReducerFlags.broadcastDiceFlags);
  }

  onBroadcastDice(callback: (ctx: ReducerEventContext, dice: string, timestamp: number) => void) {
    this.connection.onReducer("broadcast_dice", callback);
  }

  removeOnBroadcastDice(callback: (ctx: ReducerEventContext, dice: string, timestamp: number) => void) {
    this.connection.offReducer("broadcast_dice", callback);
  }

  clearPointers(tabletop: number) {
    const __args = { tabletop };
    let __writer = new BinaryWriter(1024);
    ClearPointers.getTypeScriptAlgebraicType().serialize(__writer, __args);
    let __argsBuffer = __writer.getBuffer();
    this.connection.callReducer("clear_pointers", __argsBuffer, this.setCallReducerFlags.clearPointersFlags);
  }

  onClearPointers(callback: (ctx: ReducerEventContext, tabletop: number) => void) {
    this.connection.onReducer("clear_pointers", callback);
  }

  removeOnClearPointers(callback: (ctx: ReducerEventContext, tabletop: number) => void) {
    this.connection.offReducer("clear_pointers", callback);
  }

  createTabletop(name: string, sprite: string, dimensions: Point) {
    const __args = { name, sprite, dimensions };
    let __writer = new BinaryWriter(1024);
    CreateTabletop.getTypeScriptAlgebraicType().serialize(__writer, __args);
    let __argsBuffer = __writer.getBuffer();
    this.connection.callReducer("create_tabletop", __argsBuffer, this.setCallReducerFlags.createTabletopFlags);
  }

  onCreateTabletop(callback: (ctx: ReducerEventContext, name: string, sprite: string, dimensions: Point) => void) {
    this.connection.onReducer("create_tabletop", callback);
  }

  removeOnCreateTabletop(callback: (ctx: ReducerEventContext, name: string, sprite: string, dimensions: Point) => void) {
    this.connection.offReducer("create_tabletop", callback);
  }

  deleteTabletop(id: number) {
    const __args = { id };
    let __writer = new BinaryWriter(1024);
    DeleteTabletop.getTypeScriptAlgebraicType().serialize(__writer, __args);
    let __argsBuffer = __writer.getBuffer();
    this.connection.callReducer("delete_tabletop", __argsBuffer, this.setCallReducerFlags.deleteTabletopFlags);
  }

  onDeleteTabletop(callback: (ctx: ReducerEventContext, id: number) => void) {
    this.connection.onReducer("delete_tabletop", callback);
  }

  removeOnDeleteTabletop(callback: (ctx: ReducerEventContext, id: number) => void) {
    this.connection.offReducer("delete_tabletop", callback);
  }

  editPlayer(data: PlayerData) {
    const __args = { data };
    let __writer = new BinaryWriter(1024);
    EditPlayer.getTypeScriptAlgebraicType().serialize(__writer, __args);
    let __argsBuffer = __writer.getBuffer();
    this.connection.callReducer("edit_player", __argsBuffer, this.setCallReducerFlags.editPlayerFlags);
  }

  onEditPlayer(callback: (ctx: ReducerEventContext, data: PlayerData) => void) {
    this.connection.onReducer("edit_player", callback);
  }

  removeOnEditPlayer(callback: (ctx: ReducerEventContext, data: PlayerData) => void) {
    this.connection.offReducer("edit_player", callback);
  }

  onIdentityConnected(callback: (ctx: ReducerEventContext) => void) {
    this.connection.onReducer("identity_connected", callback);
  }

  removeOnIdentityConnected(callback: (ctx: ReducerEventContext) => void) {
    this.connection.offReducer("identity_connected", callback);
  }

  onIdentityDisconnected(callback: (ctx: ReducerEventContext) => void) {
    this.connection.onReducer("identity_disconnected", callback);
  }

  removeOnIdentityDisconnected(callback: (ctx: ReducerEventContext) => void) {
    this.connection.offReducer("identity_disconnected", callback);
  }

  moveAreaOfEffect(id: number, origin: Point | undefined, target: Point | undefined) {
    const __args = { id, origin, target };
    let __writer = new BinaryWriter(1024);
    MoveAreaOfEffect.getTypeScriptAlgebraicType().serialize(__writer, __args);
    let __argsBuffer = __writer.getBuffer();
    this.connection.callReducer("move_area_of_effect", __argsBuffer, this.setCallReducerFlags.moveAreaOfEffectFlags);
  }

  onMoveAreaOfEffect(callback: (ctx: ReducerEventContext, id: number, origin: Point | undefined, target: Point | undefined) => void) {
    this.connection.onReducer("move_area_of_effect", callback);
  }

  removeOnMoveAreaOfEffect(callback: (ctx: ReducerEventContext, id: number, origin: Point | undefined, target: Point | undefined) => void) {
    this.connection.offReducer("move_area_of_effect", callback);
  }

  moveCharacter(id: number, position: Point, mountedOn: number | undefined) {
    const __args = { id, position, mountedOn };
    let __writer = new BinaryWriter(1024);
    MoveCharacter.getTypeScriptAlgebraicType().serialize(__writer, __args);
    let __argsBuffer = __writer.getBuffer();
    this.connection.callReducer("move_character", __argsBuffer, this.setCallReducerFlags.moveCharacterFlags);
  }

  onMoveCharacter(callback: (ctx: ReducerEventContext, id: number, position: Point, mountedOn: number | undefined) => void) {
    this.connection.onReducer("move_character", callback);
  }

  removeOnMoveCharacter(callback: (ctx: ReducerEventContext, id: number, position: Point, mountedOn: number | undefined) => void) {
    this.connection.offReducer("move_character", callback);
  }

  removeAreaOfEffect(id: number) {
    const __args = { id };
    let __writer = new BinaryWriter(1024);
    RemoveAreaOfEffect.getTypeScriptAlgebraicType().serialize(__writer, __args);
    let __argsBuffer = __writer.getBuffer();
    this.connection.callReducer("remove_area_of_effect", __argsBuffer, this.setCallReducerFlags.removeAreaOfEffectFlags);
  }

  onRemoveAreaOfEffect(callback: (ctx: ReducerEventContext, id: number) => void) {
    this.connection.onReducer("remove_area_of_effect", callback);
  }

  removeOnRemoveAreaOfEffect(callback: (ctx: ReducerEventContext, id: number) => void) {
    this.connection.offReducer("remove_area_of_effect", callback);
  }

  removeCharacter(id: number) {
    const __args = { id };
    let __writer = new BinaryWriter(1024);
    RemoveCharacter.getTypeScriptAlgebraicType().serialize(__writer, __args);
    let __argsBuffer = __writer.getBuffer();
    this.connection.callReducer("remove_character", __argsBuffer, this.setCallReducerFlags.removeCharacterFlags);
  }

  onRemoveCharacter(callback: (ctx: ReducerEventContext, id: number) => void) {
    this.connection.onReducer("remove_character", callback);
  }

  removeOnRemoveCharacter(callback: (ctx: ReducerEventContext, id: number) => void) {
    this.connection.offReducer("remove_character", callback);
  }

  removeEffect(id: number) {
    const __args = { id };
    let __writer = new BinaryWriter(1024);
    RemoveEffect.getTypeScriptAlgebraicType().serialize(__writer, __args);
    let __argsBuffer = __writer.getBuffer();
    this.connection.callReducer("remove_effect", __argsBuffer, this.setCallReducerFlags.removeEffectFlags);
  }

  onRemoveEffect(callback: (ctx: ReducerEventContext, id: number) => void) {
    this.connection.onReducer("remove_effect", callback);
  }

  removeOnRemoveEffect(callback: (ctx: ReducerEventContext, id: number) => void) {
    this.connection.offReducer("remove_effect", callback);
  }

  setCharacterAura(id: number, aura: number) {
    const __args = { id, aura };
    let __writer = new BinaryWriter(1024);
    SetCharacterAura.getTypeScriptAlgebraicType().serialize(__writer, __args);
    let __argsBuffer = __writer.getBuffer();
    this.connection.callReducer("set_character_aura", __argsBuffer, this.setCallReducerFlags.setCharacterAuraFlags);
  }

  onSetCharacterAura(callback: (ctx: ReducerEventContext, id: number, aura: number) => void) {
    this.connection.onReducer("set_character_aura", callback);
  }

  removeOnSetCharacterAura(callback: (ctx: ReducerEventContext, id: number, aura: number) => void) {
    this.connection.offReducer("set_character_aura", callback);
  }

  setCharacterConditions(id: number, conditions: string[]) {
    const __args = { id, conditions };
    let __writer = new BinaryWriter(1024);
    SetCharacterConditions.getTypeScriptAlgebraicType().serialize(__writer, __args);
    let __argsBuffer = __writer.getBuffer();
    this.connection.callReducer("set_character_conditions", __argsBuffer, this.setCallReducerFlags.setCharacterConditionsFlags);
  }

  onSetCharacterConditions(callback: (ctx: ReducerEventContext, id: number, conditions: string[]) => void) {
    this.connection.onReducer("set_character_conditions", callback);
  }

  removeOnSetCharacterConditions(callback: (ctx: ReducerEventContext, id: number, conditions: string[]) => void) {
    this.connection.offReducer("set_character_conditions", callback);
  }

  setCharacterInitiative(id: number, initiative: number | undefined) {
    const __args = { id, initiative };
    let __writer = new BinaryWriter(1024);
    SetCharacterInitiative.getTypeScriptAlgebraicType().serialize(__writer, __args);
    let __argsBuffer = __writer.getBuffer();
    this.connection.callReducer("set_character_initiative", __argsBuffer, this.setCallReducerFlags.setCharacterInitiativeFlags);
  }

  onSetCharacterInitiative(callback: (ctx: ReducerEventContext, id: number, initiative: number | undefined) => void) {
    this.connection.onReducer("set_character_initiative", callback);
  }

  removeOnSetCharacterInitiative(callback: (ctx: ReducerEventContext, id: number, initiative: number | undefined) => void) {
    this.connection.offReducer("set_character_initiative", callback);
  }

  setEncounter(data: SetEncounterData) {
    const __args = { data };
    let __writer = new BinaryWriter(1024);
    SetEncounter.getTypeScriptAlgebraicType().serialize(__writer, __args);
    let __argsBuffer = __writer.getBuffer();
    this.connection.callReducer("set_encounter", __argsBuffer, this.setCallReducerFlags.setEncounterFlags);
  }

  onSetEncounter(callback: (ctx: ReducerEventContext, data: SetEncounterData) => void) {
    this.connection.onReducer("set_encounter", callback);
  }

  removeOnSetEncounter(callback: (ctx: ReducerEventContext, data: SetEncounterData) => void) {
    this.connection.offReducer("set_encounter", callback);
  }

  setPageData(page: string, data: string) {
    const __args = { page, data };
    let __writer = new BinaryWriter(1024);
    SetPageData.getTypeScriptAlgebraicType().serialize(__writer, __args);
    let __argsBuffer = __writer.getBuffer();
    this.connection.callReducer("set_page_data", __argsBuffer, this.setCallReducerFlags.setPageDataFlags);
  }

  onSetPageData(callback: (ctx: ReducerEventContext, page: string, data: string) => void) {
    this.connection.onReducer("set_page_data", callback);
  }

  removeOnSetPageData(callback: (ctx: ReducerEventContext, page: string, data: string) => void) {
    this.connection.offReducer("set_page_data", callback);
  }

  updateResource(page: string, name: string, value: number) {
    const __args = { page, name, value };
    let __writer = new BinaryWriter(1024);
    UpdateResource.getTypeScriptAlgebraicType().serialize(__writer, __args);
    let __argsBuffer = __writer.getBuffer();
    this.connection.callReducer("update_resource", __argsBuffer, this.setCallReducerFlags.updateResourceFlags);
  }

  onUpdateResource(callback: (ctx: ReducerEventContext, page: string, name: string, value: number) => void) {
    this.connection.onReducer("update_resource", callback);
  }

  removeOnUpdateResource(callback: (ctx: ReducerEventContext, page: string, name: string, value: number) => void) {
    this.connection.offReducer("update_resource", callback);
  }

}

export class SetReducerFlags {
  addAreaOfEffectFlags: CallReducerFlags = 'FullUpdate';
  addAreaOfEffect(flags: CallReducerFlags) {
    this.addAreaOfEffectFlags = flags;
  }

  addCharacterFlags: CallReducerFlags = 'FullUpdate';
  addCharacter(flags: CallReducerFlags) {
    this.addCharacterFlags = flags;
  }

  addEffectFlags: CallReducerFlags = 'FullUpdate';
  addEffect(flags: CallReducerFlags) {
    this.addEffectFlags = flags;
  }

  addPointerFlags: CallReducerFlags = 'FullUpdate';
  addPointer(flags: CallReducerFlags) {
    this.addPointerFlags = flags;
  }

  broadcastDiceFlags: CallReducerFlags = 'FullUpdate';
  broadcastDice(flags: CallReducerFlags) {
    this.broadcastDiceFlags = flags;
  }

  clearPointersFlags: CallReducerFlags = 'FullUpdate';
  clearPointers(flags: CallReducerFlags) {
    this.clearPointersFlags = flags;
  }

  createTabletopFlags: CallReducerFlags = 'FullUpdate';
  createTabletop(flags: CallReducerFlags) {
    this.createTabletopFlags = flags;
  }

  deleteTabletopFlags: CallReducerFlags = 'FullUpdate';
  deleteTabletop(flags: CallReducerFlags) {
    this.deleteTabletopFlags = flags;
  }

  editPlayerFlags: CallReducerFlags = 'FullUpdate';
  editPlayer(flags: CallReducerFlags) {
    this.editPlayerFlags = flags;
  }

  moveAreaOfEffectFlags: CallReducerFlags = 'FullUpdate';
  moveAreaOfEffect(flags: CallReducerFlags) {
    this.moveAreaOfEffectFlags = flags;
  }

  moveCharacterFlags: CallReducerFlags = 'FullUpdate';
  moveCharacter(flags: CallReducerFlags) {
    this.moveCharacterFlags = flags;
  }

  removeAreaOfEffectFlags: CallReducerFlags = 'FullUpdate';
  removeAreaOfEffect(flags: CallReducerFlags) {
    this.removeAreaOfEffectFlags = flags;
  }

  removeCharacterFlags: CallReducerFlags = 'FullUpdate';
  removeCharacter(flags: CallReducerFlags) {
    this.removeCharacterFlags = flags;
  }

  removeEffectFlags: CallReducerFlags = 'FullUpdate';
  removeEffect(flags: CallReducerFlags) {
    this.removeEffectFlags = flags;
  }

  setCharacterAuraFlags: CallReducerFlags = 'FullUpdate';
  setCharacterAura(flags: CallReducerFlags) {
    this.setCharacterAuraFlags = flags;
  }

  setCharacterConditionsFlags: CallReducerFlags = 'FullUpdate';
  setCharacterConditions(flags: CallReducerFlags) {
    this.setCharacterConditionsFlags = flags;
  }

  setCharacterInitiativeFlags: CallReducerFlags = 'FullUpdate';
  setCharacterInitiative(flags: CallReducerFlags) {
    this.setCharacterInitiativeFlags = flags;
  }

  setEncounterFlags: CallReducerFlags = 'FullUpdate';
  setEncounter(flags: CallReducerFlags) {
    this.setEncounterFlags = flags;
  }

  setPageDataFlags: CallReducerFlags = 'FullUpdate';
  setPageData(flags: CallReducerFlags) {
    this.setPageDataFlags = flags;
  }

  updateResourceFlags: CallReducerFlags = 'FullUpdate';
  updateResource(flags: CallReducerFlags) {
    this.updateResourceFlags = flags;
  }

}

export class RemoteTables {
  constructor(private connection: DbConnectionImpl) {}

  get areas(): AreasTableHandle {
    return new AreasTableHandle(this.connection.clientCache.getOrCreateTable<AreaOfEffect>(REMOTE_MODULE.tables.areas));
  }

  get character(): CharacterTableHandle {
    return new CharacterTableHandle(this.connection.clientCache.getOrCreateTable<Character>(REMOTE_MODULE.tables.character));
  }

  get diceResult(): DiceResultTableHandle {
    return new DiceResultTableHandle(this.connection.clientCache.getOrCreateTable<DiceResult>(REMOTE_MODULE.tables.dice_result));
  }

  get effects(): EffectsTableHandle {
    return new EffectsTableHandle(this.connection.clientCache.getOrCreateTable<Effect>(REMOTE_MODULE.tables.effects));
  }

  get pageData(): PageDataTableHandle {
    return new PageDataTableHandle(this.connection.clientCache.getOrCreateTable<PageData>(REMOTE_MODULE.tables.page_data));
  }

  get player(): PlayerTableHandle {
    return new PlayerTableHandle(this.connection.clientCache.getOrCreateTable<Player>(REMOTE_MODULE.tables.player));
  }

  get pointers(): PointersTableHandle {
    return new PointersTableHandle(this.connection.clientCache.getOrCreateTable<Pointer>(REMOTE_MODULE.tables.pointers));
  }

  get resources(): ResourcesTableHandle {
    return new ResourcesTableHandle(this.connection.clientCache.getOrCreateTable<Resource>(REMOTE_MODULE.tables.resources));
  }

  get tabletop(): TabletopTableHandle {
    return new TabletopTableHandle(this.connection.clientCache.getOrCreateTable<Tabletop>(REMOTE_MODULE.tables.tabletop));
  }
}

export class SubscriptionBuilder extends SubscriptionBuilderImpl<RemoteTables, RemoteReducers, SetReducerFlags> { }

export class DbConnection extends DbConnectionImpl<RemoteTables, RemoteReducers, SetReducerFlags> {
  static builder = (): DbConnectionBuilder<DbConnection, ErrorContext, SubscriptionEventContext> => {
    return new DbConnectionBuilder<DbConnection, ErrorContext, SubscriptionEventContext>(REMOTE_MODULE, (imp: DbConnectionImpl) => imp as DbConnection);
  }
  subscriptionBuilder = (): SubscriptionBuilder => {
    return new SubscriptionBuilder(this);
  }
}

export type EventContext = EventContextInterface<RemoteTables, RemoteReducers, SetReducerFlags, Reducer>;
export type ReducerEventContext = ReducerEventContextInterface<RemoteTables, RemoteReducers, SetReducerFlags, Reducer>;
export type SubscriptionEventContext = SubscriptionEventContextInterface<RemoteTables, RemoteReducers, SetReducerFlags>;
export type ErrorContext = ErrorContextInterface<RemoteTables, RemoteReducers, SetReducerFlags>;
